import React from 'react';
import { useStates } from '../../hooks/StatesContext';
import ClickableStateMap from '../../components/ClickableStateMap';
import Full from '../../layouts/Full';
import FindAServicerLayout from '../../layouts/FindAServicer';
import { useRouter } from 'next/router';

function FindAServicer() {
  const states = useStates();
  let router = useRouter();

  function handleStateClick(state_abbreviation: string) {
    const state_id = states.find(state => state.state_abbreviation === state_abbreviation).state_id;

    router.push('/find-a-servicer/state/' + state_id);
  }

  return (
    <div style={{ textAlign: 'center', marginTop: 15 }}>
      <ClickableStateMap handleClick={handleStateClick} />
    </div>
  );
}

FindAServicer.getLayout = function getLayout(page) {
  return (
    <Full>
      <FindAServicerLayout>
        {page}
      </FindAServicerLayout>
    </Full>
  );
}

export default FindAServicer;
